var map = {
	"./blackGold/header/hisRecord.png": 20221,
	"./brownGold/header/hisRecord.png": 2232,
	"./darkBlue/header/hisRecord.png": 81676,
	"./greenYellow/header/hisRecord.png": 2477,
	"./redGold/header/hisRecord.png": 91509,
	"./skyBlue/header/hisRecord.png": 14019,
	"./whiteGold/header/hisRecord.png": 49346,
	"./yellowWhite/header/hisRecord.png": 89940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51044;